import styled from 'styled-components'

export const ListContainer = styled.div`
   .table th {
        background: #558fc2;
        color: #FFFFFF;
        padding: 1rem;
   }

`